import * as React from 'react';
const RenderedInstanceCountMap = new Map();
const useInstanceCount = ({
  instanceKey
}) => {
  const [instanceCount, setInstanceCount] = React.useState(0);
  React.useEffect(() => {
    const currentInstanceCount = RenderedInstanceCountMap.get(instanceKey) || 0;
    const newCount = currentInstanceCount + 1;
    setInstanceCount(newCount);
    RenderedInstanceCountMap.set(instanceKey, newCount);
    return () => {
      const currentCount = RenderedInstanceCountMap.get(instanceKey) || 0;
      RenderedInstanceCountMap.set(instanceKey, currentCount - 1);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return instanceCount;
};
export default useInstanceCount;